const pt_BR = {
  "colorpicker.opacity-input": "Opacidade",
  "datepicker.clear-date": "Limpar data",
  "datepicker.next-month": "Próximo mês",
  "datepicker.open-calendar": "Calendário aberto",
  "datepicker.previous-month": "Mês anterior",
  "input.clear": "Limpar entrada",
  "input.hide-password": "Esconder a senha",
  "input.show-password": "Mostrar senha",
  "modal.close": "Fechar",
  "multiselectchips.add-value": "Adicionar ‘{value}’",
  "multiselectchips.remove-all": "Remover tudo",
  "pagination.next-page": "Próxima página",
  "pagination.previous-page": "Página anterior"
};
export {
  pt_BR as default
};
//# sourceMappingURL=pt_BR.json.js.map
